import { ProductVariation } from 'models/productsReferential';
import { useSelector } from 'react-redux';
import { usePinnedProducts } from 'routes/essential-workspace/components/product-selector/hooks/use-pinned';
import { ProductListItem } from 'routes/essential-workspace/components/product-selector/product-list/item';
import { AppState } from 'state/state.model';
import { selectMostRecentProductsOpenedPayload } from 'state/workspaces/workspaces/workspaces.selector';

type MostRecentProductsProps = {
  products: readonly ProductVariation[];
  onSelectProduct: (product: ProductVariation) => void;
};

export function MostRecentProducts({ products, onSelectProduct }: MostRecentProductsProps) {
  const { isProductPinned } = usePinnedProducts('essential');
  const mostRecentProductsOpened = useSelector((state: AppState) =>
    selectMostRecentProductsOpenedPayload(state, 'essential'),
  );

  const recentProducts = mostRecentProductsOpened.filter(recentProduct =>
    products.some(
      product =>
        product.productType === recentProduct.productType && product.productSubType === recentProduct.productSubType,
    ),
  );

  const hasRecentProducts = recentProducts.length > 0;

  if (!hasRecentProducts) {
    return null;
  }

  return (
    <ul className="list-group list-group-flush border-top border-opacity-40" aria-label="Recently opened products">
      {recentProducts.map(product => (
        <ProductListItem
          key={`${product.productType}_${product.productSubType}`}
          product={product}
          isActive={false}
          isPinned={isProductPinned(product)}
          onSelect={onSelectProduct}
        />
      ))}
    </ul>
  );
}
